import React from "react";

export function AddPlusIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 58 58"
      width="30"
      height="30"
      {...props}
    >
      <path
        className="cls-1"
        d="m29,58C13.01,58,0,44.99,0,29S13.01,0,29,0s29,13.01,29,29-13.01,29-29,29Zm0-55C14.66,3,3,14.66,3,29s11.66,26,26,26,26-11.66,26-26S43.34,3,29,3Z"
      />
      <rect className="cls-1" x="15.67" y="27.5" width="26.4" height="3" />
      <rect className="cls-1" x="27.37" y="16.3" width="3" height="26.4" />
    </svg>
  );
}
